import { useMemo } from 'react';

import { useSharedCheckoutContext } from '@root/components/checkout/context';
import { PLANS } from '@root/constants/pricing';

import { useLastDefined } from '@utils/hooks/use_last_defined';
import { extractStoragePrice } from '@utils/pricing/pricing_set';

export const useStoragePlanInfo = () => {
  const {
    flowState: { values },
    pricingSummary,
    pricingSet,
    defaultPricingSummary,
  } = useSharedCheckoutContext();
  const { planSize, commitment } = values;

  // Keep last summary while appointment quotes refetch (matches booking_summary).
  const stablePricingSummary =
    useLastDefined(pricingSummary) ?? defaultPricingSummary;

  const amount = useMemo(() => {
    if (!planSize) return undefined;
    if (commitment && pricingSet) {
      return extractStoragePrice(commitment, planSize, pricingSet);
    }
    return stablePricingSummary?.monthlyAmount;
  }, [commitment, planSize, pricingSet, stablePricingSummary?.monthlyAmount]);

  if (!planSize || amount == null) return null;

  return {
    label: PLANS[planSize].label,
    amount,
  };
};
